// extracted by mini-css-extract-plugin
export var navbarSubLink = "L_gb d_gb d_f4 d_0 d_cc d_dm d_bs d_bT";
export var menuLink = "L_v8 d_f0 d_dB";
export var subPageLink = "L_gf d_gf";
export var burger = "L_wx";
export var sublinkSize = "L_wy";
export var linkSize = "L_wz";
export var Link = "L_vH G_vH G_t4 G_vp";